jQuery(function($) {
    var teamCarousel = $('.team-slider');
    var $cardMoreInfo = $('.card-more-info');

    // Set dynamic heights on slider items to maintain uniform appearance
    teamCarousel.on('setPosition', function() {
        $(this).find('.team-slider__item').height('auto');
        var slickTrack = $(this).find('.slick-track');
        var slickTrackHeight = $(slickTrack).height();
        $(this).find('.team-slider__item').css('height', slickTrackHeight + 'px');
    });

    // Initialize Slick slider with responsive settings
    teamCarousel.slick({
        mobileFirst: true,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span><span class="ico icon-arrow-left-simplified" aria-hidden="true"></span></button>',
        nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span><span class="ico icon-arrow-right-simplified" aria-hidden="true"></span></button>',
        responsive: [
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });

    // Toggle additional information on card click, with mobile consideration
    teamCarousel.on('click', '[data-toggle="button"]', function() {
        var $this = $(this);
        var windowWidth = $(window).width();
        var $cardTeam = $this.closest('.card--team');
        var $fullCardContent = $cardTeam.clone();

        if (windowWidth < 575) {
            var $extraInfo = $this.closest('.card-body').find('.card-extra-info');
            $extraInfo.slideToggle('fast', function() {
                var isInfoVisible = $extraInfo.is(':visible');
                var buttonText = isInfoVisible ? 'Less info' : 'More info';
                $this.find('.text-link__text').text(buttonText);
                $cardTeam.toggleClass('card--team-open', isInfoVisible);
                teamCarousel.slick('setPosition');
            });
        } else {
            // Desktop behavior: use a more-info card to display information
            if(!$cardMoreInfo.is(':visible') || !$cardMoreInfo.has($cardTeam).length) {
                closeAndResetInfo(); // Close any previously opened info
            }

            setTimeout(function() {
                var closeButtonHtml = '<button class="close-btn" aria-label="Close"><span class="visually-hidden">Close"></span><span class="ico icon-close" aria-hidden="true"></span></button>';
                $fullCardContent.prepend(closeButtonHtml);
                $cardMoreInfo.html($fullCardContent).slideToggle('fast', function() {
                    var isVisible = $cardMoreInfo.is(':visible');
                    var buttonText = isVisible ? 'Less info' : 'More info';
                    $this.find('.text-link__text').text(buttonText);
                    $cardTeam.toggleClass('card--team-open', isVisible);
                });
            }, 200);
        }
    });

    // Function to hide additional info and reset state of card elements
    function closeAndResetInfo() {
        $cardMoreInfo.slideUp('fast', function() {
            teamCarousel.find('.text-link__text').text('More info');
            teamCarousel.find('.card--team').removeClass('card--team-open');
            teamCarousel.slick('setPosition');
        });
    }

    // Handler to close card info and reset on close button click
    $(document).on('click', '.close-btn', function() {
        closeAndResetInfo();
    });

    // Ensure proper card behavior and layout on window resize
    $(window).resize(function() {
        if ($(window).width() >= 575) {
            closeAndResetInfo();
        }
    });

    // Additional handler to manage slider arrow clicks on mobile
    teamCarousel.on('click', '.slick-arrow', function() {
        if ($(window).width() < 575) {
            teamCarousel.find('.card-extra-info').hide(); // Hide extra info directly without sliding up
            teamCarousel.find('.text-link__text').text('More info');
            teamCarousel.find('.card--team').removeClass('card--team-open');
            teamCarousel.slick('setPosition'); // Re-calculate the slick position to adjust the slider height
        }
    });
});
